const initialState = {
  isBusy: !localStorage.getItem("isBusy") || localStorage.getItem("isBusy") !== "undefined" ? localStorage.getItem("isBusy") : "false"
}

const isBusy = (state = initialState, action) => {
  switch (action.type) {
    case "ALARM_BUSY":
      return { ...state, isBusy: action.val }
    default:
      return state
  }
}
export default isBusy
